import React, { FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { Input } from "@shared/ui/input";
import { DivisionSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { FilterFormPanel } from "@shared/ui/form-panel";
import type { WsDepotCardFilter } from "../../../../../../api/wsDepotCards";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import { wsDepotCardsFilterFormConfig, type WsDepotCardsFilterFormValues } from "./wsDepotCardsFilter.form-config";

/** Пропсы {@link WsDepotCardsFilterForm}. */
export type WsDepotCardsFilterFormProps = ListFilterPanelProps<WsDepotCardFilter>;

/**
 * Форма фильтра списка цеховой номенклатуры.
 */
export const WsDepotCardsFilterForm: FC<WsDepotCardsFilterFormProps> = ({ initialFilter, onApply }) => {
    const availableDivisionsSeed = useDivisionFilterSeed<WsDepotCardsFilterFormValues>("divisionCode");

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={availableDivisionsSeed}
            submissionMemory={{
                key: "workShop.wsDepotCards.filter",
                schemaVersion: 1,
                fields: ["divisionCode"],
            }}
            formProps={{ formConfig: wsDepotCardsFilterFormConfig }}
            toForm={(filter) => wsDepotCardsFilterFormConfig.toForm(filter)}
            toDomain={(values) => wsDepotCardsFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="divisionCode">
                        <DivisionSearchSelect
                            {...form.field("divisionCode").getSearchSelectProps((division) => division?.Code ?? null)}
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stockobjSign">
                        <Input {...form.field("stockobjSign").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stockobjName">
                        <Input {...form.field("stockobjName").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stockobjNomNum">
                        <Input {...form.field("stockobjNomNum").getPropsWithLabel()} />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
